/**
 * @deprecated pricing-pages-lib languageUtils is being deprecated. Use the pricing-pages-ui-components languageUtils instead.
 */
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import getLangLocale from 'I18n/utils/getLangLocale';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Raven from 'raven-js';
import * as Languages from '../constants/Languages';
export const getI18nLanguage = () => {
  // @ts-expect-error dependency missing types
  const lang = I18n.loaded && I18n.locale ? getLang() : Languages.EN;
  return lang;
};
export const getI18nLangLocale = () => {
  const langLocale =
  // @ts-expect-error dependency missing types
  I18n.loaded && I18n.locale ? getLangLocale() : `${Languages.EN}-us`;
  return langLocale;
};
export const I18nLookup = val => {
  return isValidI18nKey(val);
};

/**
 * Finds the first valid I18n key provided in keys param
 *
 * @param keys - Array of i18n keys
 */
export const findValidI18nKey = keys => {
  // @ts-expect-error dependency missing types
  return keys.find(key => I18n.lookup(key));
};
export const getI18nText = (key, options) => {
  if (!isValidI18nKey(key)) return key;
  const text = I18n.text(key, Object.assign({
    defaultValue: ''
  }, options));
  if (typeof text === 'function') {
    Raven.captureException(new Error('Attempted to call I18n.text with _jsx key'), {
      extra: Object.assign({
        key
      }, options)
    });
    return key;
  }
  return text;
};